import { render } from "./ecDashboard.vue?vue&type=template&id=5453f212"
import script from "./ecDashboard.vue?vue&type=script&lang=js"
export * from "./ecDashboard.vue?vue&type=script&lang=js"

import "./ecDashboard.vue?vue&type=style&index=0&id=5453f212&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__